import React, { Fragment } from 'react'

const Verification = ({
    cnic_number,
    cnic_front_url,
    cnic_back_url,
    cnic_front_preview,
    cnic_back_preview,
    setcnic_number,
    setCnic_front_url,
    setCnic_back_url,
    setCnic_front_preview,
    setCnic_back_preview,
    handleFileChange,
}) => {



    const handleCnicChange = (e) => {
        let value = e.target.value.replace(/\D/g, ""); // remove non digits

        if (value.length > 5 && value.length <= 12) {
            value = value.slice(0, 5) + "-" + value.slice(5);
        } else if (value.length > 12) {
            value =
                value.slice(0, 5) +
                "-" +
                value.slice(5, 12) +
                "-" +
                value.slice(12, 13);
        }



        setcnic_number(value);



    };


    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = (setImage, setPreview) => (e) => {
        e.preventDefault();

        const file = e.dataTransfer.files[0];

        if (file && (file.type === "image/png" || file.type === "image/jpeg")) {
            setImage(file);
            setPreview(URL.createObjectURL(file));
        } else {
            alert("Only PNG and JPG files are allowed!");
        }
    };




    return (
        <Fragment>
            <div className="bg-white p-6 rounded-xl border border-zinc-200 shadow-sm">
                
                {/* Header */}
                <div className="flex items-center gap-4 mb-6">
                    <div className="w-10 h-10 bg-zinc-900 rounded-lg flex items-center justify-center text-white flex-shrink-0">
                        <i className="fa-solid fa-address-card text-sm"></i>
                    </div>
                    <div>
                        <h3 className="text-base font-semibold text-zinc-900">Verification</h3>
                        <p className="text-xs text-zinc-500">Verify your CNIC.</p>
                    </div>
                </div>

                {/* CNIC Number */}
                <div className="flex flex-col mb-6">
                    <label className="text-xs font-semibold text-zinc-700 mb-1.5 uppercase tracking-wider">CNIC Number <span className="text-red-500">*</span></label>
                    <div className="flex border border-zinc-200 rounded-lg overflow-hidden focus-within:border-zinc-900 focus-within:ring-1 focus-within:ring-zinc-900 transition-all">
                        <input
                            type="text"
                            value={cnic_number}
                            onChange={handleCnicChange}
                            className="flex-1 px-4 py-2.5 outline-none text-sm text-zinc-800 placeholder-zinc-400 bg-white"
                            placeholder="Enter CNIC Number"
                        />
                        <div className="flex items-center justify-center px-4 bg-white text-zinc-400">
                            <i className="fa-regular fa-address-card text-lg"></i>
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-1 gap-6">
                    
                    {/* CNIC Front */}
                    <div className="flex flex-col">
                        <label className="text-xs font-semibold text-zinc-700 mb-1.5 uppercase tracking-wider">CNIC Front Side <span className="text-red-500">*</span></label>
                        <div
                            className="border border-dashed border-zinc-300 rounded-lg p-4 flex gap-4 items-center cursor-pointer hover:bg-zinc-50 transition-colors"
                            onDrop={handleDrop(setCnic_front_url, setCnic_front_preview)}
                            onDragOver={handleDragOver}
                            onClick={() => document.getElementById("cnicFrontInput").click()}
                        >
                            <input
                                id="cnicFrontInput"
                                type="file"
                                accept="image/png, image/jpeg"
                                onChange={handleFileChange(setCnic_front_url, setCnic_front_preview)}
                                className="hidden"
                            />
                            <div className="w-10 h-10 rounded-full bg-zinc-100 flex items-center justify-center text-zinc-600 flex-shrink-0">
                                <i className="fa-solid fa-arrow-up-from-bracket text-sm"></i>
                            </div>
                            <p className="text-xs text-zinc-500">
                                Drop your image here, or <span className="font-semibold text-zinc-900">click to upload</span>.
                            </p>
                        </div>
                        
                        {cnic_front_preview && (
                            <div className="mt-2 w-full aspect-[1.420/1] bg-zinc-100 relative overflow-hidden rounded-lg border border-zinc-200">
                                <img
                                    src={cnic_front_preview}
                                    alt="CNIC Front"
                                    className="w-full h-full object-cover"
                                />
                            </div>
                        )}
                    </div>

                    {/* CNIC Back */}
                    <div className="flex flex-col">
                        <label className="text-xs font-semibold text-zinc-700 mb-1.5 uppercase tracking-wider">CNIC Back Side <span className="text-red-500">*</span></label>
                        <div
                            className="border border-dashed border-zinc-300 rounded-lg p-4 flex gap-4 items-center cursor-pointer hover:bg-zinc-50 transition-colors"
                            onDrop={handleDrop(setCnic_back_url, setCnic_back_preview)}
                            onDragOver={handleDragOver}
                            onClick={() => document.getElementById("cnicBackInput").click()}
                        >
                            <input
                                id="cnicBackInput"
                                type="file"
                                accept="image/png, image/jpeg"
                                onChange={handleFileChange(setCnic_back_url, setCnic_back_preview)}
                                className="hidden"
                            />
                            <div className="w-10 h-10 rounded-full bg-zinc-100 flex items-center justify-center text-zinc-600 flex-shrink-0">
                                <i className="fa-solid fa-arrow-up-from-bracket text-sm"></i>
                            </div>
                            <p className="text-xs text-zinc-500">
                                Drop your image here, or <span className="font-semibold text-zinc-900">click to upload</span>.
                            </p>
                        </div>
                        
                        {cnic_back_preview && (
                            <div className="mt-2 w-full aspect-[1.420/1] bg-zinc-100 relative overflow-hidden rounded-lg border border-zinc-200">
                                <img
                                    src={cnic_back_preview}
                                    alt="CNIC Back"
                                    className="w-full h-full object-cover"
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Verification
